import { Box, Container, Grid } from '@mui/material'
import HomeSliderSkeleton from '../../../../shared/components/skeletons/HomeSliderSkeleton'
import { useHomeStyles } from '../../../../shared/styles/HomeStyles'
import SliderMoreInfo from './SliderMoreInfo'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import clsx from 'clsx'
import { Carousel } from 'react-responsive-carousel'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { useSliderClient } from '../hooks/useSliderClient'
import { LinkBlock } from './LinkBlock'

function SliderClient() {
  const isMobile = useScreenWidth(700)
  const classes = useHomeStyles()

  const {
    sliders,
    loading,
    open,
    setOpen,
    sliderSelected,
    topHomeLink,
    downLeftHomeLink,
    downRightHomeLink,
    handleClickItem,
    getMobileLinks
  } = useSliderClient()

  if (loading) {
    return <HomeSliderSkeleton />
  }

  const renderAdditionalLinks = () => {
    if (!topHomeLink) return null

    return (
      <Grid item xs={12} md={6}>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <LinkBlock
              actionOnClick={() => handleClickItem(topHomeLink)}
              image={topHomeLink.image}
              textTitle={topHomeLink.title}
              validation={true}
            />
          </Grid>

          {(downLeftHomeLink || downRightHomeLink) && (
            <Grid item>
              <Grid container spacing={1}>
                {downLeftHomeLink && (
                  <Grid item xs={12} sm={downRightHomeLink ? 6 : 12}>
                    <LinkBlock
                      actionOnClick={() => handleClickItem(downLeftHomeLink)}
                      image={downLeftHomeLink.image}
                      textTitle={downLeftHomeLink.title}
                      validation={true}
                    />
                  </Grid>
                )}
                {downRightHomeLink && (
                  <Grid item xs={12} sm={6}>
                    <LinkBlock
                      actionOnClick={() => handleClickItem(downRightHomeLink)}
                      image={downRightHomeLink.image}
                      textTitle={downRightHomeLink.title}
                      validation={true}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    )
  }

  const renderMobileLinks = () => {
    if (!topHomeLink) return null

    const mobileLinks = getMobileLinks()

    return (
      <Grid item xs={12}>
        <Carousel
          autoPlay
          showThumbs={false}
          showIndicators={false}
          showArrows={false}
          centerMode={mobileLinks.length > 1}
          interval={7000}
          dynamicHeight
          infiniteLoop
          className={clsx(classes.containercarousel, classes.containerMobile)}
        >
          {mobileLinks.map((link, index) => (
            <LinkBlock
              key={`mobile-link-${link.id || index}`}
              actionOnClick={() => handleClickItem(link)}
              image={link.image}
              textTitle={link.title}
            />
          ))}
        </Carousel>
      </Grid>
    )
  }

  return (
    <Container maxWidth="xl" sx={classes.containerLarge}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={topHomeLink ? 6 : 12}>
          <Carousel autoPlay showThumbs={false} interval={7000} infiniteLoop className={clsx(classes.containercarousel)}>
            {sliders.map((slider: any) => (
              <Box sx={classes.containerCard} key={slider.id}>
                <Box
                  position="relative"
                  overflow="hidden"
                  sx={{
                    ...classes.containerPrimary,
                    ...(slider.value === null && classes.noPointerSlider),
                    ...(topHomeLink ? {} : classes.containerPrimaryHighest),
                    cursor: slider.value ? 'pointer' : 'default'
                  }}
                  onClick={() => handleClickItem(slider)}
                >
                  <Box
                    sx={{
                      ...classes.bodyImage,
                      backgroundImage: `url(${slider.image})`
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Carousel>
        </Grid>
        {isMobile ? renderMobileLinks() : renderAdditionalLinks()}
      </Grid>

      <SliderMoreInfo slider={sliderSelected} open={open} setOpen={setOpen} />
    </Container>
  )
}

export default SliderClient
